import { createTheme } from '@mui/material';

 export const theme = createTheme({ 
    palette: {
        primary:{
            //main: "#3f51b5"
            main: '#7C9082'  //Our custom color
        }
    }
})